import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { FolderIcon16Solid } from "../../../../../icons2022/FileTypeFolderIcon/FolderIcon16Solid";
import { FolderIcon20Solid } from "../../../../../icons2022/FileTypeFolderIcon/FolderIcon20Solid";
import { FolderIcon24Solid } from "../../../../../icons2022/FileTypeFolderIcon/FolderIcon24Solid";
export var FolderIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(FolderIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(FolderIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(FolderIcon24Solid, null);
  }
}, 'FolderIcon');